import { type JsonFormTemplate } from '../../components/common/JsonForm';
import axios from 'axios';
import { basename } from '../../globals_VITE';

export interface OriginType {
  origin_type_id: number;
  name: string;
  analytics_type: number;
}

// For dropdowns, we often want a specific structure
export interface OriginTypeOption {
  value: number; // Corresponds to origin_type.id
  label: string; // Corresponds to origin_type.name
  template?: JsonFormTemplate; // The parsed form template, optional
}

interface OriginTypeOptionRaw {
  origin_type_id: number;
  name: string;
  enabled: boolean;
}

const ORIGIN_TYPE_TABLE_NAME = 'pcnt.origin_type';

const getOriginTypes = async (): Promise<OriginTypeOption[]> => {
  console.log('[originTypeApi] getOriginTypes called');
  const res = await axios.get<OriginTypeOptionRaw[]>(basename + '/pcnt/origin_type/');
  const enabled = res.data.filter(item => item.enabled);
  return enabled.map(item => ({
    ...item,
    value: item.origin_type_id,
    label: item.name,
  }));
}

const getRawOriginTypes = async (): Promise<OriginType[]> => {
  console.log('[originTypeApi] getOriginTypes called');
  const res = await axios.get<OriginType[]>(basename + '/pcnt/origin_type/');
  return res.data;
}

export const originTypeApi = {
  getOriginTypes,
  getRawOriginTypes,
};